$(function() {
  /* ヘッダー背景色アニメーション */
  if ($('.header-area').height() < $(this).scrollTop()) {
    $('.header-area').addClass('jsBackgroundHeader');
  } else {
    $('.header-area').removeClass('jsBackgroundHeader');
  }
  sliderSetting();
});
$(window).on('scroll', function() {
  /* ヘッダー背景色アニメーション */
  if ($('.header-area').height() < $(this).scrollTop()) {
    $('.header-area').addClass('jsBackgroundHeader');
  } else {
    $('.header-area').removeClass('jsBackgroundHeader');
  }
});

/* スライド */
function sliderSetting() {
  var width = $(window).width();
  if (width <= 1025) {
    $('.other-people-list')
      .not('.slick-initialized')
      .slick({
        infinite: true,
        autoplay: false,
        centerPadding: '20px',
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true,
        arrows: true,
        prevArrow: '<button class="slide-arrow prev-arrow"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"></button>',
      });
  } else {
    $('.other-people-list.slick-initialized').slick('unslick');
  }
}

$(window).resize(function() {
  sliderSetting();
});
